import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { savingsEndpoints } from "@/features/savings/api/endpoints";
import type { SavingsVaultDto } from "@/features/savings/api/dto";

/**
 * Détail d'un coffre (`GET /SavingsVaults/{id}`) : soldes
 * (`balanceMinor` / `pendingBalanceMinor` / `withdrawableBalanceMinor`),
 * blocage (`lockedUntil`, `isLocked`), objectif et progression.
 * 404 hors périmètre (sauf back-office).
 */
export const useSavingsVault = (vaultId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.SAVINGS_VAULT_DETAIL(vaultId),
    queryFn: () =>
      fetchDataGet<SavingsVaultDto>({
        url: savingsEndpoints.savingsVaults.detail(vaultId),
      }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(vaultId),
  });
